<div class="flex flex-col w-full min-w-0">
  <mat-drawer-container class="flex-auto h-full">
    <mat-drawer class="w-full dark:bg-gray-900" [ngClass]="{'sm:w-[45%] sm:min-w-[45%]': drawerOpened }"
      [autoFocus]="false" [position]="drawerPosition" [mode]="drawerMode" [opened]="drawerOpened" #drawer>
      <ng-container *ngIf="tenant_details">
        <div class="flex flex-row items-center mt-4">
          <div class="pl-8 text-xl font-semibold tracking-tight">{{tenant_details.tenant_name}} </div>
          <div class="ml-auto flex flex-row items-center">
            <mat-form-field appearance="fill" class="mini-form-field w-[22vw]">
              <input matInput placeholder="Search" type="text" required name="Search" [(ngModel)]="filtertext" />
            </mat-form-field>
            <button mat-icon-button (click)="drawer.toggle();">
              <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
          </div>
        </div>
        <mat-divider class="m-2 w-[98%]"></mat-divider>
        <div class="px-4" *ngIf="tenant_details.details && tenant_details.details.length">
          <div class="flex flex-col h-full py-6 pl-0">
            <ng-container
              *ngFor="let item of tenant_details.details | search: filtertext; let i = index; let first = first; let last = last; trackBy: trackByFn">
              <div class="dark:bg-gray-700 border border-blue-400 p-2 mb-3 rounded">
                <table class="my-2 table-auto">
                  <tbody class="text-sm font-light ">
                    <tr class="border-b">
                      <td class="px-4 py-1 text-left w-[20vw]">Company Name</td>
                      <td class="px-4 py-1 font-light text-left">
                        <i class="pr-2 text-green-400 fas fa-building"></i>
                        {{item.companyname}}
                      </td>
                    </tr>
                    <tr class="border-b">
                      <td class="px-4 py-1 text-left w-[20vw]">Probe Agents</td>
                      <td class="px-4 py-1 font-light text-left">
                        <i class="pr-2 text-green-400 fas fa-laptop-code"></i>
                        {{item.probecount| number:'1.0-0'}}
                      </td>
                    </tr>
                    <tr class="border-b">
                      <td class="px-4 py-1 text-left w-[20vw]">Lightweight Agents</td>
                      <td class="px-4 py-1 font-light text-left">
                        <i class="pr-2 text-green-400 fas fa-laptop-code"></i>
                        {{item.lightweightagentscount| number:'1.0-0'}}
                      </td>
                    </tr>
                    <tr class="border-b">
                      <td class="px-4 py-1 text-left w-[20vw]">Probe Discovered Assets</td>
                      <td class="px-4 py-1 font-light text-left">
                        <i class="pr-2 text-green-400 fas fa-laptop-code"></i>
                        {{item.assetcount| number:'1.0-0'}}
                      </td>
                    </tr>
                    <tr class="border-b">
                      <td class="px-4 py-1 text-left w-[20vw]">External Assets</td>
                      <td class="px-4 py-1 font-light text-left">
                        <i class="pr-2 text-green-400 fas fa-laptop-code"></i>
                        {{item.externalscanassetscount| number:'1.0-0'}}
                      </td>
                    </tr>
                    <ng-container *ngIf="item.vul_stats && objectKeys(item.vul_stats).length">
                      <tr class="border-b">
                        <td class="px-4 py-1 text-left w-[20vw]">Total Vulnerabilities</td>
                        <td class="px-4 py-1 text-left">
                          <span
                            class="dark:bg-blue-600 bg-blue-500 text-white text-xs rounded px-2 py-0.5">{{(item.vul_stats.critical
                            +
                            item.vul_stats.high + item.vul_stats.medium +
                            item.vul_stats.low) | number:'1.0-0'}}
                          </span>
                        </td>
                      </tr>
                      <tr class="border-b">
                        <td class="px-4 py-1 text-left w-[20vw]">Critical</td>
                        <td class="px-4 py-1 text-left">
                          <span class="cs-critical text-xs rounded px-2 py-0.5">{{item.vul_stats.critical|
                            number:'1.0-0'}}
                          </span>
                        </td>
                      </tr>
                      <tr class="border-b">
                        <td class="px-4 py-1 text-left w-[20vw]">High</td>
                        <td class="px-4 py-1 text-left">
                          <span class="cs-high text-xs rounded px-2 py-0.5">{{item.vul_stats.high| number:'1.0-0'}}
                          </span>
                        </td>
                      </tr>
                      <tr class="border-b">
                        <td class="px-4 py-1 text-left w-[20vw]">Medium</td>
                        <td class="px-4 py-1 text-left">
                          <span class="cs-medium text-xs rounded px-2 py-0.5">{{item.vul_stats.medium| number:'1.0-0'}}
                          </span>
                        </td>
                      </tr>
                      <tr class="border-b">
                        <td class="px-4 py-1 text-left w-[20vw]">Low</td>
                        <td class="px-4 py-1 text-left">
                          <span class="cs-low text-xs rounded px-2 py-0.5">{{item.vul_stats.low| number:'1.0-0'}}
                          </span>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="!tenant_details.details || !tenant_details.details.length">
          <div class="flex flex-col items-center justify-center gap-y-2 h-1/4">
            <img src="/assets/images/empty.png" alt="" class="w-20" />
            <div>No data available!</div>
          </div>
        </ng-container>
      </ng-container>
    </mat-drawer>
    <mat-drawer-content>
      <div class="w-full flex flex-col">
        <ng-container *ngIf="cs.currentScope === '*'">
          <h1 class="text-3xl mx-4 mt-4 font-bold text-gray-900 leading-tight pb-2">
            <span class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-pink-500">Inventory</span>
            <mat-icon class="ml-2 text-blue-500 cursor-pointer dark:text-blue-400 hover:text-blue-600"
            matTooltip="Download as CSV" [svgIcon]="'mat_solid:download_for_offline'"
           (click)="apiDataDownload()"></mat-icon>
          </h1>
         
          <div class="grid grid-cols-6 gap-8 p-2 m-2  min-w-0">
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-blue-500">{{customersCount}}
                </div>
                <div class="text-lg font-medium text-blue-600 dark:text-blue-500 mt-3 text-center">Total Tenants</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-lime-500">
                  {{totalCompaniesCount| number:'1.0-0'}} </div>
                <div class="text-lg font-medium text-lime-600 dark:text-lime-500 mt-3 text-center">Total Companies</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-green-500">
                  {{totalProbeCount| number:'1.0-0'}} </div>
                <div class="text-lg font-medium text-green-600 dark:text-green-500 mt-3 text-center">Probe Agents</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-emerald-500">
                  {{totalLightWeightCount| number:'1.0-0'}} </div>
                <div class="text-lg font-medium text-emerald-600 dark:text-emerald-500 mt-3 text-center">Lightweight
                  Agents</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-indigo-500">
                  {{totalAssetsCount| number:'1.0-0'}}</div>
                <div class="text-lg font-medium text-indigo-600 text-center dark:text-indigo-500 mt-3 text-center">Probe
                  Discovered Assets</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-purple-500">
                  {{totalExternalAssetCount| number:'1.0-0'}}</div>
                <div class="text-lg font-medium text-purple-600 dark:text-purple-500 mt-3 text-center">External Assets
                </div>
              </div>
            </div>
          </div>
          <mat-divider class="my-4"></mat-divider>
          <h1 class="text-3xl mx-4 mt-4 font-bold text-gray-900 leading-tight pb-2">
            <span
              class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-pink-500">Vulnerabilities</span>
          </h1>
          <div class="grid grid-cols-6 gap-8 p-2 m-2  min-w-0">
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-blue-500">
                  {{total_vul | number:'1.0-0'}}</div>
                <div class="text-lg font-medium text-blue-600 dark:text-blue-500 mt-3 text-center">Total Vulnerabilities
                </div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-[#92243e]">
                  {{critical_vul | number:'1.0-0'}}</div>
                <div class="text-lg font-medium text-[#92243e] dark:text-[#92243e] mt-3 text-center">Critical</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-[#de4a50]">
                  {{high_vul | number:'1.0-0'}}</div>
                <div class="text-lg font-medium text-[#de4a50] dark:text-[#de4a50] mt-3 text-center">High</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-[#f18c43]">
                  {{medium_vul | number:'1.0-0'}}</div>
                <div class="text-lg font-medium text-[#f18c43] dark:text-[#f18c43] mt-3 text-center">Medium</div>
              </div>
            </div>
            <div
              class="flex flex-col flex-auto p-7 bg-card shadow-lg rounded-lg overflow-hidden duration-300 ease-out transform hover:-translate-y-1 hover:scale-105">
              <div class="flex flex-col items-center m-auto">
                <div class="text-4xl sm:text-4xl font-bold tracking-tight leading-none text-[#f8c851]">
                  {{low_vul | number:'1.0-0'}}</div>
                <div class="text-lg font-medium text-[#f8c851] dark:text-[#f8c851] mt-3 text-center">Low</div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="w-full mt-4">
          <stable aria-label="All MSP" role="table"
            *ngIf="msspTableOptions && msspTableOptions.tableOptions && cs.currentScope === '*'"
            [sTableOptions]="msspTableOptions" (hyperlinkCallback)="linkClick($event)"
            (actionCallback)="actionCall($event)" (addCallback)="addCall($event)" (apiDataDownload)="apiDataDownload($event)"></stable>
        </div>
      </div>
      <div *ngIf="show_popup"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div class="absolute inset-0 overflow-hidden z-0">
          <div class="balloon-container">
            <div class="balloon balloon-1"></div>
            <div class="balloon balloon-2"></div>
            <div class="balloon balloon-3"></div>
            <div class="balloon balloon-4"></div>
          </div>
        </div>
        <div class="relative bg-white p-8 rounded-lg shadow-2xl max-w-lg text-center z-10 animate-scale-up w-[28vw]">
          <h3 class="text-3xl font-extrabold text-green-600 mb-4 animate-bounce-in">🎉 Congratulations</h3>
          <p class="text-gray-600 text-lg">Great job! You've successfully set up a new MSP.</p>
          <button (click)="show_popup = false"
            class="mt-6 px-3 py-2 bg-gradient-to-r from-green-400 to-blue-500 text-white rounded-lg hover:bg-gradient-to-l focus:outline-none shadow-lg transform hover:scale-105 transition-transform">
            Close
          </button>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
<s-modal id="addMsspModal">
  <mat-card class="modal w-[700px]">
    <form class="flex flex-col px-4 py-4 bg-card shadow rounded overflow-hidden" #partnerNgForm="ngForm">
      <mat-card-header>
        <mat-card-title class="text-lg font-medium">Add MSP Tenant</mat-card-title>
        <div class="spacer">&nbsp;</div>
        <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
          (click)="_modalService.close('addMsspModal');">
          <mat-icon>close</mat-icon>
        </button>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="my-4" fuseScrollbar>
        <fuse-alert class="mt-8" *ngIf="showAlert" [appearance]="'outline'" [showIcon]="false" [type]="alert.type"
          [@shake]="alert.type === 'error'">
          {{alert.message}}
        </fuse-alert>
        <div class="grid grid-cols-2 gap-4">
          <mat-form-field class="w-full mb-4">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Add Email" type="email" required name="email"
              [(ngModel)]="mssp_details.email" />
          </mat-form-field>
          <mat-form-field class="w-full mb-4">
            <mat-label>Tenant Name</mat-label>
            <input matInput placeholder="Add Tenant Name" type="text" required name="TenantName"
              [(ngModel)]="mssp_details.tenant_name" />
          </mat-form-field>
        </div>

        <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
          <button class="ml-auto" mat-button [matTooltip]="'Cancel'" (click)="_modalService.close('addMsspModal');">
            Cancel
          </button>
          <button class="ml-2" mat-flat-button [color]="'primary'" type="button"
            [disabled]="!(mssp_details.email && mssp_details.tenant_name) " appPreventMultiClick [matTooltip]="'Save'"
            (click)="SaveMSSP()">
            Save
          </button>
        </div>
      </mat-card-content>
    </form>
  </mat-card>
</s-modal>
<s-modal id="createMsspModal">
  <div class="max-w-full mx-auto sm:mx-0 bg-card w-[650px]">
    <div class="flex flex-row items-center px-4 pt-2">
      <div class="text-2xl font-semibold tracking-tight">{{signupConf.title}}</div>
      <button class="ml-auto" mat-icon-button (click)="close();">
        <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>
    <mat-divider class="my-4"></mat-divider>
    <app-dynamic-form [listOfFormElements]="elementList" (saveCallBack)="signup($event)"
      [Valuesoutput]="signupConf.valuesoutput" (cancelCallBack)="close()" [spanLayout]="signupConf.spanLayout"
      [fnBtnName]="signupConf.fnBtnName" [closeBtnName]="signupConf.closeBtnName"></app-dynamic-form>
  </div>
</s-modal>